/**
 * @voltxampere/web — Developer category builtin commands (Sprint 22 C3)
 *
 * 5 debug-only commands gated behind `?debug=1` per BLUEPRINT §19.7.
 * Every command's `when()` consults the search params at invocation
 * time so flipping the URL parameter without a reload still hides /
 * exposes them via search.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import type { Command } from "../types.js";
import { currentCircuit } from "../../store/circuit.js";

function isDebugMode(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get("debug") === "1";
  } catch {
    return false;
  }
}

export const DEVELOPER_COMMANDS: readonly Command[] = [
  {
    id: "dev.dump-circuit",
    titleKey: "command.dev.dumpCircuit",
    descriptionKey: "command.dev.dumpCircuit.desc",
    category: "developer",
    when: isDebugMode,
    execute: () => {
      const c = currentCircuit.value;

      console.log("[VXA dev] currentCircuit:", c ? JSON.stringify(c, null, 2) : null);
    },
  },
  {
    id: "dev.clear-storage",
    titleKey: "command.dev.clearStorage",
    descriptionKey: "command.dev.clearStorage.desc",
    category: "developer",
    when: isDebugMode,
    execute: () => {
      console.warn("[VXA dev] clear-storage stub — Sprint 23 wires IDB clear");
    },
  },
  {
    id: "dev.toggle-bench",
    titleKey: "command.dev.toggleBench",
    descriptionKey: "command.dev.toggleBench.desc",
    category: "developer",
    when: isDebugMode,
    execute: () => {
      console.info("[VXA dev] toggle-bench stub — Sprint 23 wires perf overlay");
    },
  },
  {
    id: "dev.log-recent",
    titleKey: "command.dev.logRecent",
    category: "developer",
    when: isDebugMode,
    execute: () => {
      console.info("[VXA dev] log-recent stub — Sprint 22 C4 wires recent IDB read");
    },
  },
  {
    id: "dev.replay-boot",
    titleKey: "command.dev.replayBoot",
    descriptionKey: "command.dev.replayBoot.desc",
    category: "developer",
    when: isDebugMode,
    execute: () => {
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    },
  },
];
